// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useState, useEffect } from 'react';

import MainLayout from '../../layouts/MainLayout';
import MemberLayout from '../../layouts/MemberLayout';
import { prependZero } from '../../lib/utility';
import Pagination from '../../components/Pagination'
import Tabs from './Tabs'
import { TabType, TabContentProps } from './Tabs/Tabs'

import LoadingAnimation from '../../assets/images/load.gif'
import { getOrders, cancelOrder } from '../../apis/ec';
import { Orders, courseTransaction } from '../../types/Orders';
import { S } from './OrdersPageStyles';

interface OrdersHistoryTableProps {
  data: Orders[];
  refetchTrigger: Function;
}

function parsePaymentMethod(method: string) {
  switch (method) {
    case 'ecpay_credit_onetime':
      return '信用卡';
    case 'ecpay_atm':
      return 'ATM 轉帳'
    case 'ecpay_cvs':
      return '超商付款'
  }
}

function parsePaymentState(state: string) {
  switch (state) {
    case 'Paid':
      return '*發票已寄至個人電子郵件，請至電子郵件查看發票明細'
    case 'Wait':
      return '等待付款'
    case 'Cancelled':
      return '取消成功'
  }
}

function parseDate(date: Date) {
  return (
    <>
      {
        (new Date(date)).getFullYear() +
      '/' +
      prependZero((new Date(date)).getMonth() + 1) +
      '/' +
      prependZero((new Date(date)).getDate()) +
      ' - ' +
      prependZero((new Date(date)).getHours()) +
      ':' +
      prependZero((new Date(date)).getMinutes()) +
      ':' +
      prependZero((new Date(date)).getSeconds())
      }
    </>
  )
}

interface CourseItemDetailProps {
  value: Orders;
}

function CourseItemDetail({ value }: CourseItemDetailProps) {
  return (
    <>
      <S.ContainerText style={{marginLeft: '10px'}}>課程名稱</S.ContainerText>
      <S.ContainerText align="center">售價</S.ContainerText>
      <S.ContainerText align="center">折扣</S.ContainerText>
      <S.ContainerText align="left" style={{ marginRight: '10px'}}>應付金額</S.ContainerText>
      <S.TableLine />
      {
        value.items.map((course: courseTransaction) => {
          const netPrice =
            value.target ?
              value.target?.onlineCourseIds ?
                value.target?.onlineCourseIds.includes(course.id) ?
                  course.price - Math.floor(value.target?.off * course.price)
                  :
                  course.price
                :
                course.price - Math.floor(value.target?.off * course.price)
              :
              course.price

          return (
            <>
              <S.ContainerProductTitle style={{marginLeft: '10px', overflowWrap: 'break-word'}}>{course.name}</S.ContainerProductTitle>
              <S.ContainerProductTitle align="center">NT$ {course.price}</S.ContainerProductTitle>
              {
                (value.target && !value.target.onlineCourseIds) || value.target?.onlineCourseIds.includes(course.id) ?
                  <S.ContainerProductTitle color="red" align="center">- NT$ {Math.floor(value.target?.off * course.price)}</S.ContainerProductTitle>
                  :
                  <S.ContainerProductTitle align="center">-</S.ContainerProductTitle>
              }
              <S.ContainerProductTitle align="left" style={{ marginRight: '10px'}}>NT$ {netPrice}</S.ContainerProductTitle>
            </>
          )
        })
      }
    </>
  )
}

const OrdersTable = (props: OrdersHistoryTableProps) => {
  const [visibleDetailIds, setVisibleDetailIds] = useState<number[]>([])

  async function handleCancelOrder(orderNo: string) {
    await cancelOrder(orderNo);
    props.refetchTrigger();
  }

  return (
    <>
      {
        props.data.map((value, index) => (
          <S.Container key={index}>
            <S.ContainerTopGrid>
              <S.ContainerText>訂單成立： {parseDate(value.purchaseTime)} </S.ContainerText>
              <S.ContainerText>付款方式： {parsePaymentMethod(value.paymentMethod)}</S.ContainerText>
              <S.ContainerText color="red" align="right">{parsePaymentState(value.paymentState)}</S.ContainerText>
              <S.ContainerText>付款時間： {value.paymentState === 'Paid' ? parseDate(value.ecpayInfo.PaymentDate) : '-'}</S.ContainerText>
              <S.ContainerText>訂單編號： {value.orderNo}</S.ContainerText>
              {
                value.ecpayInfo?.BankCode ?
                  (
                    <S.ContainerText>轉入帳戶： {value.ecpayInfo?.BankCode} - {value.ecpayInfo?.vAccount}</S.ContainerText>
                  ) : null
              }
            </S.ContainerTopGrid>

            <S.ContainerText
              color="yellow"
              style={{
                display: 'flex',
                justifyContent: 'flex-end'
              }}
            >
              問問題
            </S.ContainerText>

            <S.ShowTableButton
              onClick={() => {
                visibleDetailIds.includes(value.id)
                  ? setVisibleDetailIds(visibleDetailIds.filter((item) => item !== value.id))
                  : setVisibleDetailIds(visibleDetailIds.concat(value.id));
              }}
              active={visibleDetailIds.includes(value.id)}
            >
              查看明細
            </S.ShowTableButton>

            <S.ContainerBottomGrid>
              {
                visibleDetailIds.includes(value.id) ? (<CourseItemDetail value={value}/>) : null
              }

              <S.TableLine />
              <S.ContainerProductTitle style={{marginLeft: '10px'}}>總金額</S.ContainerProductTitle>
              <S.ContainerProductTitle
                style={{
                  gridColumnStart: '4',
                  gridColumnEnd: '4',
                  marginRight: '10px'
                }}
              >
                NT$ {value.totalAmount}
              </S.ContainerProductTitle>
            </S.ContainerBottomGrid>
            {
              value.paymentState === 'Wait' ?
                (
                  <S.CancelButton
                    onClick={() => handleCancelOrder(value.orderNo)}
                  >
                  取消訂單
                  </S.CancelButton>
                ) : null
            }
            {/* <pre>{JSON.stringify(value, null, 2)}</pre> */}
          </S.Container>
        )
        )}
    </>
  );
};

interface OrdersPage {
  count: number;
  page: number;
  totalPage: number;
  limit: number;
  list: Orders[];
}

export default function () {
  const [ordersPage, setOrdersPage] = useState<OrdersPage>({
    count: 1,
    page: 1,
    totalPage: 0,
    limit: 5,
    list: []
  });
  const [tab, setTab] = useState<TabType>(1);
  const [isFetching, setIsFetching] = useState<boolean>(false);
  const [isFetchingNewTabs, setIsFetchingNewTabs] = useState<boolean>(false);

  function parseTab(tab: TabType) {
    switch (tab) {
      case 1:
        return 'Paid';
      case 2:
        return 'Wait'
      case 3:
        return 'Cancelled'
      default:
        return 'Error'
    }
  }

  async function fetchData(tab: TabType) {
    if (!isFetching) {
      setIsFetching(true);
      const { data } = await getOrders(ordersPage.page, ordersPage.limit, parseTab(tab));
      setIsFetching(false);
      setIsFetchingNewTabs(false);
      setOrdersPage(data);
    }
  }

  function handlePagination(page: number) {
    setOrdersPage({...ordersPage, page})
  }

  useEffect(() => {
    fetchData(tab);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab, ordersPage.page]);

  const changeData = (value: TabType) => {
    setTab(value);
    setIsFetchingNewTabs(true);
    setOrdersPage({...ordersPage, page: 1});
  };

  const TABS: Array<TabContentProps> = [
    { value: 1, title: '完成訂單' },
    { value: 2, title: '等待付款' },
    { value: 3, title: '失效訂單' },
    { value: 4, title: '兌換紀錄' }
  ];

  return (
    <MainLayout>
      <MemberLayout>
        <S.ShadowBoxContainer>
          <S.ShadowBox>
            <Tabs list={TABS} defaultValue={tab} onClick={changeData} />
            {
              isFetching ? (
                <S.LoadingContainer>
                  <img src={LoadingAnimation} alt="loading" style={{ width: '20%'}}/>
                  <S.LoadingText>載入中。。。</S.LoadingText>
                  {
                    isFetchingNewTabs ? null : (
                      <Pagination
                        pageLength={ordersPage.totalPage}
                        style={{ marginTop: '68px', justifyContent: 'center' }}
                        page={ordersPage.page}
                        onClick={handlePagination}
                      />
                    )
                  }
                </S.LoadingContainer>
              ) : ordersPage.list.length === 0 ? (
                <S.LoadingContainer>
                  <S.LoadingText>目前無{TABS[tab - 1].title}</S.LoadingText>
                </S.LoadingContainer>
              ) : (
                <div style={{ padding: '40px 50px' }}>
                  <OrdersTable
                    data={ordersPage.list}
                    refetchTrigger={() => fetchData(tab)}
                  />
                  <Pagination
                    pageLength={ordersPage.totalPage}
                    style={{ marginTop: '68px', justifyContent: 'center' }}
                    page={ordersPage.page}
                    onClick={handlePagination}
                  />
                </div>
              )
            }
          </S.ShadowBox>
        </S.ShadowBoxContainer>
      </MemberLayout>
    </MainLayout>
  );
}
